import { compareServiceId } from '.';
import { ORDER_EVALUATION, ORDER_POPULAR, ORDER_RETURN } from '../constants/select';
import { FX } from '../constants';

const concatHighPrioritySortFunc = (sortFunc) => {
  return (a, b) => {
    if (a.recommendation && b.recommendation) {
      // serviceId に含まれるのがサービスIDと MIXED(all) のみなので compareServiceId が利用可能
      // serviceIdが違う場合serviceIdでソートする。同じ場合はrecommendationSortでソートする
      if (a.serviceId === b.serviceId) {
        return a.recommendationSort - b.recommendationSort;
      }
      return compareServiceId(a.serviceId, b.serviceId);
    }
    if (a.recommendation) {
      return -1;
    }
    if (b.recommendation) {
      return 1;
    }
    // 以下はおすすめを含まない要素の比較
    return sortFunc(a, b);
  };
};

const compareReturn = (a, b) => {
  const result = b.simulationStats.roi - a.simulationStats.roi;
  if (result === 0) {
    // シェアの場合、第2ソートキーは ID
    return (b.labId ?? 0) - (a.labId ?? 0);
  }
  return result;
};

export const getSortedData = (option, data) => {
  let sortingFunc;
  const sortingData = [...data];
  switch (option) {
    case ORDER_RETURN: {
      sortingFunc = compareReturn;
      break;
    }
    case ORDER_POPULAR: {
      sortingFunc = (a, b) => {
        const result =
          (b.cartAddedCount ?? b.simulationStats.instanceCount) - (a.cartAddedCount ?? a.simulationStats.instanceCount);
        if (result === 0) {
          // シェアの場合、第2ソートキーは ID
          return (b.labId ?? 0) - (a.labId ?? 0);
        }
        return result;
      };
      break;
    }
    case ORDER_EVALUATION: {
      sortingFunc = (a, b) => {
        const ca1 = a.attribute?.comprehensiveEvaluation ?? 0;
        const ca2 = b.attribute?.comprehensiveEvaluation ?? 0;
        const result = ca2 - ca1; // 大きい順
        if (result === 0) {
          // 第2ソートは Return順
          return compareReturn(a, b);
        }
        return result;
      };
      break;
    }
    default: {
      sortingFunc = () => 0;
    }
  }
  return sortingData.sort(concatHighPrioritySortFunc(sortingFunc));
};

export const getParentTag = (tags, parentTagId) => tags?.find((tag) => tag.tagId === parentTagId);

export const getDefaultChild = (tags, parentTagId) => {
  const children = getParentTag(tags, parentTagId)?.children ?? [];
  const found = children.find(({ defaultFlg }) => defaultFlg);
  if (found) {
    return found;
  }
  if (children.length) {
    return children[0];
  }
  return null;
};

export const formatCurrencyLabel = (symbol, serviceId) => {
  const label = serviceId === FX ? '通貨' : '銘柄';
  if (!symbol || symbol.length === 0) return '';
  return symbol.length >= 2 ? `${symbol.length}${label}` : symbol[0];
};
